module.exports = __webpack_public_path__ + "f18b758d6050abacfaf3baa4f6d36991.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/new_york_times_2023_chart.png
// module id = 1699
// module chunks = 0